// "As low as $X a month" on an option (BL-005): from the company's financing plans (Settings › Prices),
// read once per session; nothing with no plans, or when the total is under every plan's minimum. The
// customer applies on the lender's link, when there is one.
import { useEffect, useState } from 'react';
import { client } from '../api.ts';
import { asLowAsWords, safeApplyUrl, type FinancingSetting } from '../settings/financing-model.ts';

let read: Promise<FinancingSetting | null> | null = null;
const financing = () =>
  (read ??= client
    .call<{ value: FinancingSetting }>('settings.get', { key: 'payments.financing' })
    .then((r) => r.value)
    .catch(() => {
      read = null; // try again next time
      return null;
    }));

export function AsLowAs({ totalCents }: { totalCents: number }) {
  const [v, setV] = useState<FinancingSetting | null>(null);
  useEffect(() => {
    let live = true;
    void financing().then((x) => live && setV(x));
    return () => {
      live = false;
    };
  }, []);
  const words = asLowAsWords(totalCents, v);
  if (!words) return null;
  // https only, whatever was saved (QA-666)
  const apply = safeApplyUrl(v?.applyUrl);
  return (
    <p className="small muted as-low-as">
      {words}
      {apply && (
        <>
          {' · '}
          <a href={apply} target="_blank" rel="noreferrer">
            Apply with {v?.lender}
          </a>
        </>
      )}
    </p>
  );
}
